<div class="ats-layout">
  <ats-side-menu
    [menuItems]="!isPartners ? menuItems() : partnersMenuItems"
    [bottomItem]="feedbackMenuItem"
    [favoriteItems]="!isPartners ? favoriteItems() : []"
    [favoriteIds]="!isPartners ? favoriteIds() : []"
    [collapsed]="collapsed()"
    [version]="version"
    (favoriteToggle)="onFavoriteToggle($event)"
    (orderChange)="onOrderChange($event)"
    (favoritesReorder)="onFavoritesReorder($event)"
    (onChange)="onMenuStateChange($event)"
    (themeChange)="toggleTheme()"
    (settingsOpen)="openSettingsModalV2()"
    (searchOpen)="openSpotlightModal()">
    @if (!isPartners) {
      <button type="button" atsTemplate="search" class="ats-side-menu-search-wrapper" data-testid="app.search" (click)="openSpotlightModal()">
        <i class="i i-search"></i>
        <span class="ats-side-menu-search-content">
          <span class="ats-side-menu-search-placeholder">Search</span>
          <span class="flex align-items-center gap-2">
            <span class="key-badge"><i class="i i-cmd"></i></span>
            <span class="key-badge">K</span>
          </span>
        </span>
      </button>
    }
    <div class="logo-full" atsTemplate="full-logo">
      @if (isLightTheme()) {
        <img src="./assets/icons/logo_full_flat_light.svg" alt="ATSystems" />
      } @else {
        <img src="./assets/icons/logo_full_flat_dark.svg" alt="ATSystems" />
      }
    </div>
    <div atsTemplate="short-logo" class="logo-short">
      @if (isLightTheme()) {
        <img src="./assets/icons/logo_short_flat_light.svg" alt="A" />
      } @else {
        <img src="./assets/icons/logo_short_flat_dark.svg" alt="A" />
      }
    </div>
    @if (!isPartners) {
      <button *atsHasRole="internalAccessRole" type="button" atsTemplate="settings" class="settings-entry" data-testid="app.settings" title="Settings" [class.collapsed]="collapsed()" (click)="openSettingsModalV2()">
        <ats-icon icon="i i-cog"></ats-icon>
        @if (!collapsed()) {
          <span class="settings-entry-text">Settings</span>
        }
      </button>
    }
    <div atsTemplate="bottom-buttons">
      <div class="flex buttons_bottom justify-content-between">
        <div class="sign-out flex gap-2" data-testid="app.sign-out" (click)="signOut()">
          <ats-icon icon="i i-sign-out"></ats-icon>
          <div class="sign-out-text">Sign out</div>
        </div>
        <div class="ats-side-menu-button" data-testid="app.theme-toggle" (click)="toggleTheme()">
          @if (isLightTheme()) {
            <ats-icon icon="atsi atsi-moon"></ats-icon>
          }
          @if ((isLightTheme()) === false) {
            <ats-icon icon="atsi atsi-sun"></ats-icon>
          }
        </div>
      </div>
    </div>
    <div atsTemplate="page" class="ats-page-router">
      <router-outlet></router-outlet>
    </div>
  </ats-side-menu>
</div>

<ats-toast></ats-toast>
@if (showIsOffline) {
  <div class="ats-offline-message flex" data-testid="app.offline-message" [class.minimize]="isOfflineMinimize">
    <ats-icon data-testid="app.offline-expand" class="icon mr-3" icon="i i-wifi" (click)="isOfflineMinimize && toggleOfflineMessageSize()"></ats-icon>
    @if (!isOfflineMinimize) {
      <div class="wrapper">
        <div class="flex justify-content-between align-items-start">
          <div class="ats-offline-message__title mb-2">Connections is lost</div>
          <ats-icon data-testid="app.offline-minimize" class="min-btn cursor-pointer" icon="i i-window-minimize" (click)="toggleOfflineMessageSize()"></ats-icon>
        </div>
        <div class="ats-offline-message__message">It looks like your internet connection is lost, you should check it out or you can play dinosaur in a new tab</div>
      </div>
    }
  </div>
}
